import { render } from "./index.vue?vue&type=template&id=6eb6de80&scoped=true?status=10"
import script from "./index.vue?vue&type=script&lang=js?status=10"
export * from "./index.vue?vue&type=script&lang=js?status=10"

import "./index.vue?vue&type=style&index=0&id=6eb6de80&lang=less&scoped=true?status=10"

import exportComponent from "/Users/qiao/KaungSpace/DevSpace/KaungAdmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6eb6de80"]])

export default __exports__